import { render, staticRenderFns } from "./StockShipmentsPanel.vue?vue&type=template&id=22649177&scoped=true"
import script from "./StockShipmentsPanel.vue?vue&type=script&lang=js"
export * from "./StockShipmentsPanel.vue?vue&type=script&lang=js"
import style0 from "./StockShipmentsPanel.vue?vue&type=style&index=0&id=22649177&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22649177",
  null
  
)

export default component.exports